// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__dwDZt","leftContent":"styles_leftContent__JQpBY","btn":"styles_btn__Pt-JI","text":"styles_text__pEluY"};